<template>
  <div>
    <el-dialog :visible.sync="visible" width="1280px" :close-on-click-modal="false" @close="handleClose">
      <span slot="title" class="dialog-title">混凝土结算</span>

      <div class="bill_top">
        <span><span class="text">结算时间段：</span>{{ localRow.lastDueTime || '--' }} 至 {{ localRow.currentDueTime || '--' }}</span>
        <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="openCheckDetail">核对明细单</el-button>
      </div>

      <!-- 产品结算表格 -->
      <div class="bill_title1">产品结算</div>
      <vxe-table border show-footer show-overflow="tooltip" height="400" align="center"
        :data="detailData.productSummarys" :footer-method="productFooterMethod">
        <vxe-column field="startTime" title="价格时间段" width="250">
          <template #default="{ row }">
            <span v-if="row.startTime">{{ row.startTime }} - {{ row.endTime }}</span>
            <span v-else>-</span>
          </template>
        </vxe-column>
        <vxe-column field="settleItem" title="结算项" width="150">
          <template #default="{ row }">
            <span v-if="row.settleItem == 1">图算结算单</span>
            <span v-else-if="row.settleItem == 2">票结结算单</span>
            <span v-else>-</span>
          </template>
        </vxe-column>
        <vxe-column field="productName" title="产品名称" min-width="150" />
        <vxe-column field="amount" title="数量(m³)" width="120" />
      </vxe-table>

      <!-- 调价结算表格 -->
      <div v-if="detailData.differSummarys && detailData.differSummarys.length" class="bill_title1">调价结算</div>
      <vxe-table v-if="detailData.differSummarys && detailData.differSummarys.length" border show-footer show-overflow
        align="center" :data="detailData.differSummarys" :footer-method="differFooterMethod">
        <vxe-column field="timeSlot" title="调价时间段" width="400">
          <template #default="{ row }">
            {{ row.startTime }} 至 {{ row.endTime }}
          </template>
        </vxe-column>
        <vxe-column field="adjustType" title="调整类型" width="150" />
        <vxe-column field="productName" title="产品名称" />
        <vxe-column field="amount" title="数量(m³)" width="120" />
        <vxe-column field="differPrice" title="价差(元)" width="120" />
        <vxe-column field="differMoney" title="结算额(元)" width="140" />
      </vxe-table>

      <!-- 泵类别结算合计 -->
      <div class="bill_title1">泵类别结算合计</div>
      <vxe-table border show-footer show-overflow align="center" :data="detailData.pumpSummarys"
        :footer-method="commonFooterMethod">
        <vxe-column field="product" title="产品名称" />
        <vxe-column field="amount" title="数量(m³)" />
      </vxe-table>

      <!-- 其他项结算合计 -->
      <div class="bill_title1">其他项结算合计</div>
      <vxe-table border show-footer show-overflow align="center" :data="detailData.smallVolumeSummarys"
        :footer-method="commonFooterMethod">
        <vxe-column field="product" title="产品名称" />
        <vxe-column field="amount" title="数量(m³)" />
      </vxe-table>

      <!-- 撤回原因、备注、事项说明 -->
      <div class="bill_title1">撤回原因</div>
      <el-input v-model="detailData.rejectReason" type="textarea" :rows="3" disabled />
      <div class="bill_title1">备注</div>
      <el-input v-model="detailData.remark" type="textarea" :rows="3" disabled />
      <div class="bill_title1">事项说明</div>
      <el-input v-model="detailData.eventExplain" type="textarea" :rows="3" disabled />

      <!-- 合同附件 -->
      <div class="bill_title">合同附件</div>
      <div v-for="(item, index) in contractFiles" :key="index" style="color:#00b85c">
        <el-link type="success" :underline="false" @click="lookFileDetail(item)">{{ item.fileName }}</el-link>
        <a class="el-link" @click="downloadFile(item)"><i class="el-icon-download" style="padding:0 10px"></i></a>
      </div>

      <!-- 结算附件 -->
      <div class="bill_title1">附件</div>
      <FileComponent fileCode="settlementFile" :disabled="true" :files="settlementFiles" />

      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="visible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 核对明细单弹窗 -->
    <checkDetail
      :visible.sync="checkDetailDig"
      :checkDetailType="4"
      :centerRow="currentRow"
      :stationIdlist="stationIdlist"
      :isLook="true"
      :disClostDetail="disClostDetail"
      :cycleId="cycleId"
      :bindEngList="bindEngList"
      @resetCheckDetail="checkDetailDig = false"
    />
  </div>
</template>

<script>
import { queryProcessSettleData, getStationByCompanyId, getDisClostDetail } from "@/api/wise/settlementTask.js";
import FileComponent from "@/views/platform/ICPS/internetSales/components/fileComponent";
import checkDetail from "@/views/platform/ICPS/Wise/checkDetail.vue";

export default {
  name: "SettlementDetailDialog",
  components: { FileComponent, checkDetail },
  props: {
    rowData: {           // 整个行的数据对象
      type: Object,
      required: true,
      default: () => ({})
    },
    value: {             // 控制弹窗显示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      dataReady: false,
      localRow: {},      // 存储传入的行数据
      detailData: {
        productSummarys: [],
        differSummarys: [],
        pumpSummarys: [],
        smallVolumeSummarys: [],
        rejectReason: '',
        remark: '',
        eventExplain: ''
      },
      contractFiles: [],
      settlementFiles: [],
      checkDetailDig: false,
      stationIdlist: [],
      disClostDetail: {},
      cycleId: null,
      bindEngList: [],
      currentRow: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val;
        if (val && this.rowData && this.rowData.id) {
          // 保存一份本地行数据
          this.localRow = { ...this.rowData };
          this.initAllData();
        }
      },
      immediate: true
    },
    rowData: {
      handler(newVal) {
        if (this.visible && newVal && newVal.id) {
          this.localRow = { ...newVal };
          this.initAllData();
        }
      },
      deep: true
    }
  },
  methods: {
    async initAllData() {
      this.dataReady = false;
      await Promise.all([
        this.fetchDetail(),
        this.fetchStationList(),
        this.fetchDisClostDetail(),
        this.fetchContractFiles()
      ]);
      this.dataReady = true;
    },
    fetchDetail() {
      return queryProcessSettleData({ id: this.localRow.id }).then(res => {
        if (res.code === 1001 && res.data) {
          const data = res.data;
          const auditTotal = data.auditTotal || {};
          this.detailData = {
            productSummarys: data.productSummarys || [],
            differSummarys: data.differSummarys || [],
            pumpSummarys: data.pumpSummarys || [],
            smallVolumeSummarys: data.smallVolumeSummarys || [],
            rejectReason: auditTotal.rejectReason || '',
            remark: auditTotal.remark || '',
            eventExplain: auditTotal.eventExplain || ''
          };
          this.cycleId = data.cycleId || this.localRow.id;
          // 构建 currentRow 供核对明细单使用
          this.currentRow = {
            id: this.localRow.id,
            engineeringId: this.localRow.engineeringId,
            lastDueTime: this.localRow.lastDueTime,
            currentDueTime: this.localRow.currentDueTime,
            engineeringName: data.engineeringName || this.localRow.engineeringName || '',
            settleStatus: 4
          };
          if (auditTotal.enclosureUrl) {
            try {
              this.settlementFiles = JSON.parse(auditTotal.enclosureUrl);
            } catch (e) { this.settlementFiles = []; }
          } else { this.settlementFiles = []; }
          this.detailData.differSummarys.forEach(item => {
            if (item.startTime && item.endTime) item.timeSlot = [item.startTime, item.endTime];
          });
        } else {
          this.$message.error(res.codeMsg || '获取结算详情失败');
          this.visible = false;
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('加载失败，请稍后重试');
        this.visible = false;
      });
    },
    fetchStationList() {
      if (!this.localRow.engineeringId) return Promise.resolve();
      return getStationByCompanyId({ engineeringId: this.localRow.engineeringId }).then(res => {
        if (res.code === 1001) {
          this.stationIdlist = res.data || [];
        }
      }).catch(err => console.error('获取站点列表失败', err));
    },
    fetchDisClostDetail() {
      if (!this.localRow.engineeringId) return Promise.resolve();
      return getDisClostDetail({ id: this.localRow.engineeringId }).then(res => {
        if (res.code === 1001) {
          this.disClostDetail = res.data || {};
          // 补充工程名称到 currentRow
          if (!this.currentRow.engineeringName && this.disClostDetail.engineeringName) {
            this.currentRow.engineeringName = this.disClostDetail.engineeringName;
          }
        }
      }).catch(err => console.error('获取工程合同信息失败', err));
    },
    fetchContractFiles() {
      if (!this.localRow.engineeringId) return Promise.resolve();
      return getDisClostDetail({ id: this.localRow.engineeringId }).then(res => {
        if (res.code === 1001 && res.data) {
          // 合同附件从 fileFist 字段获取
          this.contractFiles = res.data.fileFist || [];
        }
      }).catch(err => console.error('获取合同附件失败', err));
    },
    openCheckDetail() {
      if (!this.dataReady) {
        this.$message.warning('数据加载中，请稍后再试');
        return;
      }
      // 确保工程名称已填充
      if (!this.currentRow.engineeringName && this.disClostDetail.engineeringName) {
        this.currentRow.engineeringName = this.disClostDetail.engineeringName;
      }
      this.checkDetailDig = true;
    },
    handleClose() { this.$emit('input', false); },
    lookFileDetail(item) {
      if (item.path && (item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.path.endsWith('.jpeg'))) {
        window.open('https://lvshe.huashijc.com/file/' + item.path, '_blank');
      } else if (item.path) {
        this.$wps(item.path);
      } else {
        this.$message.warning('文件路径无效');
      }
    },
    downloadFile(item) {
      window.open('https://lvshe.huashijc.com/file/' + item.path, '_blank');
    },
    productFooterMethod({ columns, data }) {
      return [columns.map(column => {
        if (column.title === '数量(m³)') return data.reduce((s, i) => s + (Number(i.amount) || 0), 0).toFixed(3);
        if (column.title === '价格时间段') return '小计';
        return null;
      })];
    },
    differFooterMethod({ columns, data }) {
      return [columns.map(column => {
        if (column.title === '调价时间段') return '小计';
        if (column.title === '数量(m³)') return data.reduce((s, i) => s + (Number(i.amount) || 0), 0).toFixed(3);
        if (column.title === '结算额(元)') return data.reduce((s, i) => s + (Number(i.differMoney) || 0), 0).toFixed(2);
        return null;
      })];
    },
    commonFooterMethod({ columns, data }) {
      return [columns.map(column => {
        if (column.title === '产品名称') return '小计';
        if (column.title === '数量(m³)') return data.reduce((s, i) => s + (Number(i.amount) || 0), 0).toFixed(3);
        return null;
      })];
    }
  }
};
</script>

<style scoped>
.bill_top { display: flex; justify-content: flex-start; line-height: 35px; flex-wrap: wrap; margin-bottom: 16px; }
.bill_top .text { font-weight: 600; color: #000; }
.bill_title1 { font-size: 18px; font-weight: 600; padding: 20px 0 10px 0; }
.bill_title { font-size: 18px; font-weight: 600; padding: 15px 0; }
</style>